module.exports = __webpack_public_path__ + "img/bala_writing_explanation.3bcfb1dc.png";